import { add, differenceInMilliseconds, isPast } from 'date-fns';
/**
 * Returns the time until a date in days, hours, minutes and seconds.
 */
export function getCountdownForDate(date) {
    if (isPast(date))
        return expiredCountdown;
    const duration = differenceInMilliseconds(date, Date.now());
    return {
        days: Math.floor(duration / (1000 * 60 * 60 * 24)),
        hours: Math.floor((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((duration % (1000 * 60)) / 1000)
    };
}
export const expiredCountdown = { days: 0, hours: 0, minutes: 0, seconds: 0 };
export const isExpiredCountdown = (countdown) => {
    if (!countdown)
        return false;
    const { days, hours, minutes, seconds } = countdown;
    return days === 0 && hours === 0 && minutes === 0 && seconds === 0;
};
export const getDateForDurationFromNow = (duration) => {
    return add(new Date(), duration);
};
export const compareDateCountdown = (compareDaysOnly = false, ascending = true) => {
    return (a, b) => {
        let result = 0;
        if (a.days !== b.days)
            result = a.days - b.days;
        if (!compareDaysOnly) {
            if (a.hours !== b.hours)
                result = a.hours - b.hours;
            else if (a.minutes !== b.minutes)
                result = a.minutes - b.minutes;
            else if (a.seconds !== b.seconds)
                result = a.seconds - b.seconds;
        }
        return ascending ? result : result * -1;
    };
};
